// extracted by mini-css-extract-plugin
export default {"illustration-56-56":"EatingHabits-module__illustration-56-56__MRCcP"};